var map = {
	"./cert-finance-cpttm-sc.jpg": 283,
	"./cert-fsi-cpttm-sc.jpg": 285,
	"./cert-general-staff-a-cpttm-sc.jpg": 287,
	"./cert-general-staff-cpttm-sc.jpg": 289,
	"./cert-general2024-cpttm-sc.jpg": 219,
	"./cert-senior-manager-cpttm-sc.jpg": 295,
	"./cert-student-cpttm-sc.jpg": 298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2938;